module.exports = __webpack_public_path__ + "static/media/a16.eaf2ca22.pdf";